import React, { useState, useCallback, useEffect } from "react";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./RerouteModalStyles.css";
import { AtomizerJobAPI } from "../../../API/api";
import { toast } from "react-toastify";

const modalTitleStyle = {
    color: "rgb(42, 54, 74)",
    fontSize: "20px",
    fontFamily: "Helvetica",
};
const textStyles1 = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word', overflowWrap: 'break-word',
    textAlign: "left",
    display: "flex",
    justifyContent: "center",
    width: "100%"


};
export default function UnPublishMultipleModal() {
    const [isLoading, isLoaded] = useState(false);
    const successMsg = (message) => {
        return (
            <>
                <span style={{ fontSize: "12px" }}>{message}</span>
            </>
        );
    };
    const modalState = useSelector((state) => state.domain);
    const ingestedState = useSelector((state) => state.drawer.tableDataCurrent);
    const dispatch = useDispatch();
    const { advanceFilterModalToggle, ingestedrefreshData ,RefreshAction} = bindActionCreators(Actions, dispatch);
      const state = useSelector((state) => state.drawer);
    const onClickButtons = () => {
        isLoaded(true);
        let newLists = ingestedState.map(obj => {
            let data = {
                "thread": obj.docType === 'Thread' ? true : false,
                "jobId": obj.docType === 'Thread' ? obj.jobid : "",
                "soId": obj.docType === 'Thread' ? "" : obj.soId
            }
            return data;
        });
        let payload = {
            action: 'unpublish',
            data: newLists
        }
        AtomizerJobAPI(payload).then(res => {
            if (res === undefined) return;
            if (res.data.success) {
                toast.success(successMsg(res.data.message));
                ingestedrefreshData(120);
                RefreshAction(!state.refreshState)
                advanceFilterModalToggle({ bool: false, value: "" });
                isLoaded(false);
            }
            ingestedrefreshData(120);
            RefreshAction(!state.refreshState)
            advanceFilterModalToggle({ bool: false, value: "" });
            isLoaded(false);

            // ingestedrefreshData(0);
            // RefreshAction(!state.refreshState)
            // advanceFilterModalToggle({ bool: false, value: "" });
            // isLoaded(false);
        })
    }
    return (
        <>
            {/* <Modal show={modalState.modalState}
            onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
            centered={true}
            size={"md"}
            style={{marginTop:"-50px"}}
            // scrollable={true}
        >
            <ModalHeader className="reroutetitleModal" closeButton closeVariant="white">
                <ModalTitle>
                    <h5 className="headingModal"><i className="fa fa-book" style={{ paddingRight: "7px", fontSize: "16px" }}></i>Unpublish Documents</h5>
                </ModalTitle>
            </ModalHeader>
            <ModalBody>
                <div className="row" style={{paddingLeft:'3.0rem',paddingRight:'3.0rem',paddingBottom:'5px', textAlign:'center'}}>
                    <div className="container">
                        <p style={{fontWeight:'bold',marginBottom:'5px'}}>Are you sure that you want to unpublish all of these documents?</p>
                        <p style={{fontWeight:'100', fontSize:'12px',marginTop:'2px', color:'grey'}}>Note: Already unpublish document will be ignored.</p>
                        {!isLoading && <div>
                            <button className="cancelBtn" onClick={()=>advanceFilterModalToggle({ bool: false, value: "" })}>No</button>&nbsp;
                            <button className="rerouteBtn"  onClick={()=>onClickButtons()}>Yes</button></div>}
                        {isLoading && 
                        <div>
                            <button className="loadingpublishbutton" disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;UnPublishing</button>
                        </div>}
                    </div>
                </div>
            </ModalBody>
        </Modal> */}

            <Modal
                show={modalState.modalState}
                onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
                centered={true}
                size={"md"}
                style={{ marginTop: "-50px" }}
            >
                {/* <ModalHeader closeButton>
                <ModalTitle style={modalTitleStyle}>
                  <h5
                    style={{
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <i
                      className="fa fa-book"
                      style={{ paddingRight: "7px", fontSize: "16px" }}
                    ></i>
                    {ingestedState.title}
                  </h5>
                </ModalTitle>
              </ModalHeader> */}
                <Modal.Header closeButton>
                    <Modal.Title style={modalTitleStyle}>
                        <span>
                        <i className="fa fa-book" >&nbsp;&nbsp;</i>Unpublish Documents
                            {/* <i class="fa fa-book" aria-hidden="true"> </i> &nbsp;&nbsp; {ingestedState.title} */}
                        </span>


                    </Modal.Title>
                </Modal.Header>
                <ModalBody>
                    <div
                        className="row"
                        style={{
                            paddingLeft: "3.0rem",
                            paddingRight: "3.0rem",
                            paddingBottom: "5px",
                            textAlign: "center",
                        }}
                    >
                        <div className="container">
                            <p style={textStyles1}>
                                Are you sure that you want to unpublish all of these documents?
                            </p>

                            {!isLoading && (
                                <div>
                                    <button
                                        style={{
                                            padding: '8px 12px 8px 12px',
                                            borderRadius: '6px',
                                            fontSize: '14px',
                                            lineHeight: '24px',
                                            fontWeight: 400,
                                            boxShadow: ' 0px 1px 2px 0px #1018280D',
                                            color: '#2A364A',
                                            border: '1px solid  #fff',
                                            height: '40px',
                                            minWidth: '88px',
                                            background: " #F6F7F8",
                                            marginBottom: '14px',
                                            fontWeight: 400,
                                            border: " 1px solid #E0E2E6",
                                            cursor: "pointer",
                                            //  font-weight: 400;			
                                        }}

                                        // className="rerouteBtn"
                                        onClick={() => advanceFilterModalToggle({ bool: false, value: "" })}
                                    >
                                        No
                                    </button>
                                    &nbsp;
                                    <button
                                        style={{
                                            padding: '8px 12px 8px 12px',
                                            borderRadius: '6px',
                                            fontSize: '14px',
                                            lineHeight: '24px',
                                            fontWeight: 400,
                                            boxShadow: ' 0px 1px 2px 0px #1018280D',
                                            color: 'white',
                                            border: '1px solid  #fff',
                                            height: '40px',
                                            minWidth: '88px',
                                            background: " #F6F7F8",
                                            marginBottom: '14px',
                                            fontWeight: 400,
                                            border: " 1px solid #E0E2E6",
                                            cursor: "pointer",
                                            background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                            //  font-weight: 400;			
                                        }}
                                        onClick={() => onClickButtons()}
                                    >
                                        Yes
                                    </button>
                                </div>
                            )}

                            {isLoading && (
                                <div>
                                    <button style={{
                                        padding: '8px 12px 8px 12px',
                                        borderRadius: '6px',
                                        fontSize: '14px',
                                        lineHeight: '24px',
                                        fontWeight: 400,
                                        boxShadow: ' 0px 1px 2px 0px #1018280D',
                                        color: 'white',
                                        border: '1px solid  #fff',
                                        height: '40px',
                                        minWidth: '88px',
                                        background: " #F6F7F8",
                                        marginBottom: '14px',
                                        fontWeight: 400,
                                        border: " 1px solid #E0E2E6",
                                        background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                                        cursor: "not-allowed",
                                        //  font-weight: 400;			
                                    }}
                                        disabled>
                                        <i className="fa fa-spinner"></i>&nbsp;&nbsp;UnPublishing...
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}
